import { Content, Header, Page } from '@backstage/core-components';
import { Grid, Typography } from '@material-ui/core';

import { PDPHeaderWorldClock } from './PDPHeaderWorldClock';
import { PDPWelcomeTitle } from './PDPWelcomeTitle';
import { SearchBar } from './SearchBar';
import { AdditionalContent } from './prototype/AdditionalContent';
import { EngineeringNewsCard } from './prototype/EngineeringNewsCard';
import { LearningResources } from './prototype/LearningResources';
import { RfcCard } from './rfcs/RfcCard';

const headerTitle = <PDPWelcomeTitle />;
const headerSubtitle = "Welcome to Principal's Developer Portal!";

export const HomePage = () => (
  <Page themeId="tool">
    <Header
      title={headerTitle}
      subtitle={headerSubtitle}
      pageTitleOverride="Welcome to PDP!"
    >
      <PDPHeaderWorldClock />
    </Header>

    <Content>
      <Grid container spacing={1} style={{ padding: 20 }}>
        <SearchBar />
        <Grid style={{ padding: '60px 24px 10px 24px' }}>
          <Typography variant="h2" data-testid="home-h2-header">
            A portal designed to support engineers
          </Typography>
          <Typography variant="body1" paragraph>
            The Principal Developer Portal is the source for standardized
            enterprise resources, guidelines and documentation. The information
            within this portal is intended to provide engineers with the tools
            to quickly and easily meet the needs of the role.
          </Typography>
        </Grid>
        <Grid container style={{ padding: 0 }}>
          <Grid item lg={8} md={6} sm={12}>
            <EngineeringNewsCard />
          </Grid>
          <Grid item lg={4} md={6} sm={12}>
            <RfcCard />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ padding: '90px 0px 90px 0px' }}>
          <AdditionalContent />
        </Grid>
        <LearningResources />
      </Grid>
    </Content>
  </Page>
);
